import React from "react";
import { useTranslation } from "react-i18next";
import { useAppStoreState } from "store/AppStore";
import { useClientBalancePageStore } from "store/ClientBalancePageStore";

import { VSpace } from "components/Spacer";
import GrecoReactGrid, {
  standardCellTypeHandlers,
} from "components/grecoreactgrid/GrecoReactGrid";
import DatePickerCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/DatePickerCellTypeHandler";
import { infoEntriesColumnConfig as bankStatementInfoEntriesColumnConfig } from "pages/BankStatements/BankStatementEntriesGrid/InfoBankStatementEntryDialog/infoEntriesColumnConfig";
import SortableHeaderCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/SortableHeaderCellTypeHandler";
import TaxonomyCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/TaxonomyCellTypeHandler";
import CustomTextCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/CustomTextCellTypeHandler";
import CustomNumberCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/CustomNumberCellTypeHandler";
import { useTheme } from "@emotion/react";
import SumHeaderCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/SumHeaderCellTypeHandler";
import CustomCheckmarkCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/CustomCheckmarkCellTypeHandler";
import OrdinalNumberCellTypeHandler from "components/grecoreactgrid/customcelltypehandlers/OrdinalNumberCellTypeHandler";

const PaymentsByClientSaldoEntryGrid = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { taxonomy } = useAppStoreState();
  const clientBalancePageStore = useClientBalancePageStore();
  const [
    {
      paymentsByClientSaldoEntry,
      paymentsByClientSaldoEntryMetadataMap,
      paymentsByClientSaldoEntrySort,
    },
    { setClientBalancePageStoreValue },
  ] = clientBalancePageStore;

  const handleChanges = (
    _updatedRows: any[],
    _updatedRowsMetadataMap: { [key: number]: any }
  ) => {
    // read-only grid
  };

  const cellTypeHandlers = {
    ...standardCellTypeHandlers,
    taxonomy: new TaxonomyCellTypeHandler(),
    datepicker: new DatePickerCellTypeHandler(),
    sortableheader: new SortableHeaderCellTypeHandler(),
    sumheader: new SumHeaderCellTypeHandler(),
    customnumber: new CustomNumberCellTypeHandler(),
    customtext: new CustomTextCellTypeHandler(),
    customcheckmark: new CustomCheckmarkCellTypeHandler(),
    ordinalnumber: new OrdinalNumberCellTypeHandler(),
  };

  return (
    <div
      data-help="client-balance-info-payments-grid"
      style={{ height: "350px", overflow: "auto" }}
    >
      <div
        style={{
          width: "calc(100% - 5px)",
          height: "calc(100% - 30px)",
          overflow: "scroll",
        }}
      >
        {paymentsByClientSaldoEntry.filter((el) => !el.isDeleted).length > 0 ? (
          <GrecoReactGrid
            rows={paymentsByClientSaldoEntry}
            columns={bankStatementInfoEntriesColumnConfig}
            idColumn={"paymentId"}
            rowsMetadataMap={paymentsByClientSaldoEntryMetadataMap}
            handleChanges={handleChanges}
            cellTypeHandlers={cellTypeHandlers}
            keyColumn="paymentId"
            stickyColumns={{
              left: 2,
              top: 1,
              bottom: 1,
              right: 2,
            }}
            context={{
              taxonomy: taxonomy,
              t: t,
              clientBalancePageStore: clientBalancePageStore,
              theme: theme,
              sort: paymentsByClientSaldoEntrySort,
              setSort: (sort: any) => {
                setClientBalancePageStoreValue(
                  "paymentsByClientSaldoEntrySort",
                  sort
                );
              },
            }}
            sort={paymentsByClientSaldoEntrySort}
          />
        ) : null}
      </div>
      <VSpace height={25} />
    </div>
  );
};

export default PaymentsByClientSaldoEntryGrid;
